import pako from 'pako';

const b64DecodeUnicode = (str: string) => {
    return decodeURIComponent(
        Array.prototype.map.call(atob(str), (c: string) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }
        ).join(''));
};

const arrayBufferToBase64 = (buffer: Uint8Array) => {
    let binary = '';
    const bytes: number[] = [].slice.call(buffer);
    bytes.forEach((b) => binary += String.fromCharCode(b));
    return window.btoa(binary);
};

export const getEncodedToken = (token: string) => {
    const tokenParts = token.split('.');

    const dec0 = b64DecodeUnicode(tokenParts[0]);
    const def0 = pako.deflateRaw(dec0, { level: 9 });
    const enc0 = arrayBufferToBase64(def0);
    
    const dec1 = b64DecodeUnicode(tokenParts[1]);
    const def1 = pako.deflateRaw(dec1, { level: 9 });
    const enc1 = arrayBufferToBase64(def1);

    const encodedToken = enc0 + '.' + enc1 + '.' + tokenParts[2];
    return encodeURIComponent(encodedToken);
};